var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.VL=require("moment");module.exports=$CLJS.VL;